import React from 'react';
import { SimpleGrid, Heading, Box } from '@chakra-ui/react';
import RelatedPostCard from './RelatedPostCard';

const RelatedPosts = ({ posts, onCardClick }) => {
  return (
    <Box mt={8} mb={4}>
      <Heading as="h3" fontSize={{ base: 'xl', md: '2xl' }} color="blue.900" mb={6}>
        Related Post
      </Heading>
      <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} spacing={6}>
        {posts.map((post, idx) => (
          <RelatedPostCard
            key={idx}
            image={post.image}
            tag={typeof post.tag === 'object' ? 
              (post.tag?.fullName || post.tag?.name || "News") : 
              (post.tag || "News")}
            title={post.title}
            desc={post.desc}
            post_desc={post.post_desc}
            isVideo={post.isVideo}
            videoUrl={post.videoUrl}
            onClick={onCardClick ? () => onCardClick(post, idx) : undefined}
          />
        ))}
      </SimpleGrid>
    </Box>
  );
};

export default RelatedPosts; 